/*
  HEROCK — Barra de compra fija en móvil.

  Aparece cuando el botón de compra real sale de pantalla al hacer scroll, y
  desaparece cuando vuelve a verse. No duplica el formulario: su botón usa el
  atributo `form`, así que envía el mismo formulario con la variante que el
  cliente tenga seleccionada. Sin estado que sincronizar, sin desajustes.

  Al mostrarse marca <html> con `hr-has-sticky-atc`, que sube la burbuja de
  WhatsApp por encima de la barra (ver hr-pdp.css). Son los dos únicos
  elementos fijos de la página y en 375px se pisan si no se coordinan.

  Sin JS o sin IntersectionObserver, la barra simplemente no aparece: el botón
  de compra normal sigue funcionando.
*/
class HrStickyAtc extends HTMLElement {
  connectedCallback() {
    this.anchor = document.getElementById(this.dataset.anchorId);
    if (!this.anchor || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const anchorVisible = entries[0].isIntersecting;
        this.toggleAttribute('hidden', anchorVisible);
        document.documentElement.classList.toggle('hr-has-sticky-atc', !anchorVisible);
      },
      { rootMargin: '0px 0px -20% 0px' }
    );
    this.observer.observe(this.anchor);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    document.documentElement.classList.remove('hr-has-sticky-atc');
  }
}

if (!customElements.get('hr-sticky-atc')) {
  customElements.define('hr-sticky-atc', HrStickyAtc);
}
